import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./app/store/store";
import { AlertProvider } from "./app/components/AlertContextComponent";
import { QueryClient, QueryClientProvider } from "react-query";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
const queryClient = new QueryClient();

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <AlertProvider>
        <App />
      </AlertProvider>
    </QueryClientProvider>
  </Provider>,
);
// Remove loader after page render
const loader = document.getElementById("loader");
if (loader) {
  loader.style.display = "none";
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(Logger.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
